import { atomFamily } from 'recoil'

export type PermissionFeature = {
  isPermitted: boolean
  acceptedPermissions: string[]
  missingPermissions: string[]
}

const featurePermissionsAtomFamily = atomFamily<PermissionFeature | null, string>({
  key: 'featurePermissions',
  default: null,
})

const isLoadingPermissionsAtomFamily = atomFamily<boolean, string>({
  key: 'isLoadingPermissions',
  default: false,
})

export { featurePermissionsAtomFamily, isLoadingPermissionsAtomFamily }
